import { createContext, useContext } from 'react';

const DrawerStackItemContext = createContext({ isActive: false });

export const useDrawerStackItem = () => useContext(DrawerStackItemContext);

export default DrawerStackItemContext;
